import React, { Component } from 'react';
import Tibbit_base from '@appblocks/frontend/client/Components/TPP/Tibbit_base';

export default class Tibbit_connector_narrow extends Tibbit_base {
    constructor(props: any) {
        super(props);
        this.width = 48.63;
        this.height = 46.93;
    }

    render() {
        return (
            <g id="connector_narrow" {...this.props} className="tibbit">
                <rect className="draggable" x="0" y="0" width="45.63" height="46.93" transform="translate(-1, 1) " />
                <polygon className="moduleColor_connector" points="9.877,-0.043 9.877,1.086 2.258,1.086 2.258,-0.043 0,-0.043 &#10;&#9;&#9;0,48.894 2.258,48.894 2.258,47.765 9.877,47.765 9.877,48.894 44.633,48.894 44.633,-0.043 " />

                <rect className="recess" x="40.663" y="4.78" width="3.971" height="39.291" />
                <rect className="recess" x="2.258" y="1.086" width="7.62" height="46.68" />

                <rect className="labelColor" x="13.264" y="3.554" width="24.552" height="41.741" />

                <g id="label">
                    <text transform="matrix(0 -1 1 0 22 8)" className="label" textAnchor="end" id="num">{this.props.num}</text>
                    <text transform="matrix(0 -1 1 0 28 43)" className="desc" id="desc">
                        {this.renderDescriptions()}
                    </text>
                </g>

                <polygon className="tibbitStroke" points="9.877,-0.043 9.877,1.086 2.258,1.086 2.258,-0.043 0,-0.043 &#10;&#9;&#9;0,48.894 2.258,48.894 2.258,47.765 9.877,47.765 9.877,48.894 44.633,48.894 44.633,-0.043 " />
                {this.renderWiring()}
            </g>
        );
    }
}
